import React from 'react'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import {withRouter} from 'react-router'

@withGraphQL(
  gql`
    query getMe {
      me {
        _id
        hasAcceptedLastTermsOfService
      }
    }
  `,
  {
    options: {
      fetchPolicy: 'network-only'
    }
  }
)
@withRouter
export default class TermsVerifier extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    me: PropTypes.object,
    children: PropTypes.node
  }
  componentDidUpdate() {
    this.checkRoute()
  }
  getAllowedRoutes() {
    return ['/terms-of-service-updated', '/privacy-policy', '/terms-and-conditions', '/']
  }
  checkRoute() {
    if (!this.props.me) return
    const {pathname} = this.props.router.location
    const allowedRoutes = this.getAllowedRoutes()
    if (!allowedRoutes.includes(pathname) && !this.props.me.hasAcceptedLastTermsOfService) {
      this.props.router.push('/terms-of-service-updated')
    }
  }
  render() {
    if (!this.props.me) return this.props.children
    this.checkRoute()
    return this.props.children
  }
}



// WEBPACK FOOTER //
// ./src/App/Root/TermsVerifier/index.js